import { render, staticRenderFns } from "./bo-announcement-popup.vue?vue&type=template&id=2c6ba6ac"
import script from "./bo-announcement-popup.vue?vue&type=script&lang=js"
export * from "./bo-announcement-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports